import React from 'react';
import { useLocation, Redirect } from 'umi';
export default () => {
  const { pathname } = useLocation();
  let redirect = '';
  // 情报处理
  if (pathname.startsWith('/intelligence_detail')) {
    // /intelligence_detail /intelligence_detail/intelligence_detail   /intelligence_detail/yd
    redirect = pathname.replace(/^\/intelligence_detail/, '').replace(/^\/intelligence_detail/, '').replace(/^\/yd/, '');
    if (!redirect.toLowerCase().startsWith('/home')) {
      // redirect = '/intelligence' + redirect;
      redirect = '/intelligence/topCharts/mobileGames';
    }
  }

  return <>
    <Redirect to={redirect || '/home'} />
  </>;
}
